import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateAppleWalletProvisionRequest,
  TCreateAppleWalletProvisionResponse,
} from "./createAppleWalletProvision.schema";

export const createAppleWalletProvision = (axios: IAxiosInstance) => {
  return async (
    params: TCreateAppleWalletProvisionRequest
  ): Promise<IApiResponse<TCreateAppleWalletProvisionResponse>> => {
    const { paycard_id, ...body } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TCreateAppleWalletProvisionResponse>
    >(`/api/pay-cards/${paycard_id}/apple-wallet-provision`, body);
    return response.data;
  };
};
